import React, { useEffect } from 'react';
import { auth, authLoginTimestamp, authVmLoginTimestamp, logOut, user } from './slices/auth-slice';
import { useAppDispatch, useAppSelector } from './app/hooks';
import { showAlert } from './components/Swal';
import { logout } from './commonFunction';

const AuthExpiryChecker: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(auth);
  const lastVMLoginTimestamp = useAppSelector(authVmLoginTimestamp);
  const loginTimestamp = useAppSelector(authLoginTimestamp)

  useEffect(() => {
    const checkSession = () => {
      if (isAuthenticated) {
        const currentTime = new Date().getTime();
        const vmLoginElapsedTime = (currentTime - (lastVMLoginTimestamp || 0)) / (1000 * 60);
        const loginElapsedMinutes = (currentTime - loginTimestamp) / (1000 * 60);

        if (loginElapsedMinutes >= 55) {
          showAlert({
            title: "The session is expired. Please login again!",
            confirmButtonText: "Ok",
            confirmCallback: () => {
              logout()
            }
          });
        }
        // else if (vmLoginElapsedTime >= 55) {
        //   performVMLogin();
        // }
      }
    };

    checkSession();

    const interval = setInterval(checkSession, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [dispatch, isAuthenticated, lastVMLoginTimestamp]);

  return <>{children}</>;
};

export default AuthExpiryChecker;